module.exports = __webpack_public_path__ + "media/6-z.d5230a8f.wav";